import React, {
  useState,
  useEffect,
  useContext,
  ClipboardEvent,
  useRef,
} from "react";
import {
  Container,
  Col,
  Row,
  Form,
  InputGroup,
  Button,
  Modal,
} from "react-bootstrap";
import { useCallback } from "react";
import styles from "./Login.module.css";
import { Link, useNavigate } from "react-router-dom";
import { RxEyeClosed } from "react-icons/rx";
import { MdRemoveRedEye } from "react-icons/md";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import {
  AutenticarUsuarioRest_Respuesta,
  builtAutenticarUsuarioRest_Datos,
  AutenticarUsuarioRest_Parametros,
  AutenticarUsuarioRest_Datos,
} from "../Commons/Services/AutenticarUsuarioRest";
import { ConsultaWS } from "../Commons/ServiciosBase";

import {
  ConsultaCuenta_Respuesta,
  ConsultaCuentaRest_Parametros,
  ConsultaCuentaRest_Entrada,
  builtConsultaCuentaRestInput,
  ServiceInstance,
} from "../Commons/Services/ConsultaCuentaRest";
import axios from "axios";
import {
  ConsultarServiciosCuenta_Respuesta,
  ConsultarServiciosCuenta_Parametros,
  builtInputVarConsultarServiciosCuentaInput,
  ConsultarServiciosCuenta_Entrada,
  ServicioEBO,
} from "../Commons/Services/ConsultarServiciosCuentaRest";

import encryptText from "../Commons/EncriptText";

import {
  ConsultarIRD_Entrada,
  ConsultarIRD_Parametros,
  ConsultarIRD_Respuesta,
  Tarjeta,
} from "../Commons/Services/ConsultarIRD";
import BarraLoader from "../General/BarraLoader";
import { getAssetsFromSalesfoce, getPrimaryData } from "../Utils/GetAssetsUtil";
import {
  AccountDetails_Entrada,
  AccountDetails_Parametros,
  AccountDetails_Respuesta,
} from "../Commons/Services/AccountDetails";
import ContextFlujos from "../Context/ContextFlujos";

import {
  ReenviarCorreo_Entrada,
  ReenviarCorreo_Parametros,
  ReenviarCorreo_Respuesta,
  builtReenviarCorreoInput,
} from "../Commons/Services/ReenviarCorreo";
import { Asset } from "../Commons/Services/GetAssets4SkyCelular";
import {
  ConsultarCuentaEspecial_Entrada,
  builtConsultarCuentaEspecial_Entrada,
  ConsultarCuentaEspecial_Parametros,
  ConsultarCuentaEspecial_Respuesta,
} from "../Commons/Services/ConsultarCuentaEspecial";
import {
  ConsultarCuentaAsociada_Entrada,
  builtConsultarCuentaAsociada_Entrada,
  ConsultarCuentaAsociada_Parametros,
  ConsultarCuentaAsociada_Respuesta,
} from "../Commons/Services/ConsultarCuentaAsociada";

import {
  ConsultarDatosUsuario_Respuesta,
  ConsultarDatosUsuario_Entrada,
  builtConsultarDatosUsuario_Entrada,
  ConsultarDatosUsuario_Parametros,
} from "../Commons/Services/ConsultarDatosUsuario";
var regExDir = /^(?!\s)[A-Za-z0-9-_@.+\s]+$/; //solo para letras, numeros espacios punto, guion, guion bao y arroba

const { REACT_APP_CAPTCHA_KEY } = process.env;

export const Login = () => {
  const captchaRef = useRef<ReCAPTCHA>(null);
  const [capchaToken, setCapchaToken] = useState<string>("");
  const [solicitudCorreo, isSolicitudCorreo] = useState(false);
  const [mensajeSolicitudCorreo, setMensajeSolicitudCorreo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const flujo = sessionStorage.getItem("flujos");
  const handleCloseModal = () => {
    setShowModal(false);
    setCorreoReenvio("");
    setCorreoReenvioConfirma("");
    setStatusModal({
      show: false,
      color: "red",
      message: "",
    });

    setStatusCorreoRe({
      show: false,
      color: "red",
      message: "",
    });

    setStatusCorreoReConfirma({
      show: false,
      color: "red",
      message: "",
    });

    isLoading(false);
    isSolicitudCorreo(false);
  };
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModalError = () => setShowModalError(false);
  const handleShowModalError = () => setShowModalError(true);
  const [correoReenvio, setCorreoReenvio] = useState("");
  const [correoReenvioConfirma, setCorreoReenvioConfirma] = useState("");
  const [statusModal, setStatusModal] = useState({
    show: false,
    color: "red",
    message: "",
  });

  const [statusCorreoRe, setStatusCorreoRe] = useState({
    show: false,
    color: "red",
    message: "",
  });

  const [statusCorreoReConfirma, setStatusCorreoReConfirma] = useState({
    show: false,
    color: "red",
    message: "",
  });

  const validarCampo = (e: any, campo: string) => {
    if (campo === "correo") {
      setCorreoReenvio(e);
      if (e === "") {
        setStatusCorreoRe({
          show: true,
          color: "red",
          message: "E-mail es requerido",
        });
      } else {
        setStatusCorreoRe({
          show: false,
          color: "red",
          message: "",
        });
      }
    }
    if (campo === "confirmar") {
      setCorreoReenvioConfirma(e);
      if (e === "") {
        setStatusCorreoReConfirma({
          show: true,
          color: "red",
          message: " Confirmar E-mail es requerido",
        });
      } else {
        setStatusCorreoReConfirma({
          show: false,
          color: "red",
          message: " Confirmar E-mail es requerido",
        });
      }
    }
  };

  const doReenviarCorreoRest = async () => {
    const ReenviarCorreoRestDO: ReenviarCorreo_Entrada =
      builtReenviarCorreoInput(`${correoReenvio}`, "SKY");
    let par = ReenviarCorreo_Parametros(ReenviarCorreoRestDO);
    let ReenvioCorreoRespuesta: ReenviarCorreo_Respuesta =
      await ConsultaWS(par);

    if (
      ReenvioCorreoRespuesta.EBMHeaderResponse &&
      ReenvioCorreoRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
      ReenvioCorreoRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
    ) {
      isLoading(false);

      setMensajeSolicitudCorreo(
        " El correo electrónico de confirmación ha sido enviado"
      );

      isSolicitudCorreo(true);
    } else {
      isLoading(false);
      //
      setMensajeSolicitudCorreo(
        ReenvioCorreoRespuesta.EBMHeaderResponse.ErrorNegocio.DescripcionError
      );
      isSolicitudCorreo(true);
    }
  };

  const handleReenviarCorreoSubmit = async () => {
    setStatusModal({ show: false, color: "red", message: "" });

    if (correoReenvio == "" || correoReenvioConfirma == "") {
      setStatusModal({
        show: true,
        color: "red",
        message: "Todos los campos son obligatorios",
      });
      console.error(status.message);
      return;
    } else if (correoReenvio == "") {
      setStatusCorreoRe({
        show: true,
        color: "red",
        message: "E-mail es requerido",
      });
    } else if (correoReenvioConfirma == "") {
      setStatusCorreoReConfirma({
        show: true,
        color: "red",
        message: "Confirmar E-mail es requerido",
      });
    } else {
      //setStatusModal({ show: true, color: "red", message: "Validando..." });
      isLoading(true);
      doReenviarCorreoRest();
    }
  };

  const [passwordShown, setPasswordShown] = useState(false);
  const [usuarioPlaceholder, setUsuarioPlaceholder] = useState("");
  const [imagenURI, setImagenURI] = useState(logo);

  const [datosSW, setDatosSW] = useState<AutenticarUsuarioRest_Respuesta>();
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [status, setStatus] = useState({
    show: false,
    color: "red",
    message: "",
  });
  const [loading, isLoading] = useState(false);

  const [typePwd, setTypePwd] = useState("password");

  const handleShowNumber = () =>
    setTypePwd(typePwd === "password" ? "text" : "password");

  const navigate = useNavigate();

  const {
    setBti,
    setSkyPlus,
    setSkyCelular,
    setTipoClienteContext,
    setPais,
    setDTHSkyPlus,
  } = useContext(ContextFlujos) as any;

  const [banderaPais, setBanderaPais] = useState(false);

  const validarNulosYIndefinidios = (param: any) => {
    var retorno: string = "";
    if (param != null && typeof param != "undefined") {
      retorno = param;
    } else {
      retorno = "";
    }

    return retorno;
  };

  const doConsultaCuenta = async (param: AutenticarUsuarioRest_Respuesta) => {
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultaCuentaRestDO: ConsultaCuentaRest_Entrada =
      builtConsultaCuentaRestInput(
        `${
          flujo === "Sky+"
            ? sessionStorage.getItem("cuenta")!
            : (sessionStorage.getItem("cuenta")! ?? "")
        }`
      );
    let consultaCuentaRest_Parametro =
      ConsultaCuentaRest_Parametros(ConsultaCuentaRestDO);
    let consultaCuentaRespuesta: ConsultaCuenta_Respuesta = await ConsultaWS(
      consultaCuentaRest_Parametro
    );
    sessionStorage.setItem("isReload", "0");
    sessionStorage.setItem("isDamgesReload", "0");
    if (
      consultaCuentaRespuesta.EBMHeaderResponse &&
      consultaCuentaRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
      consultaCuentaRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok" &&
      consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
        .ListOfServiceInstance !== null &&
      typeof consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
        .Account[0].ListOfServiceInstance !== "undefined"
    ) {
      sessionStorage.setItem(
        "countryCode",
        validarNulosYIndefinidios(
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .AccountCountryCode
        )
      );

      sessionStorage.setItem(
        "MSISDN",
        validarNulosYIndefinidios(
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .ListOfServiceInstance.ServiceInstance[0].MSISDN
        )
      );

      sessionStorage.setItem(
        "tipoCliente",
        validarNulosYIndefinidios(
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .BillPaymentSystem
        )
      );
      setTipoClienteContext(
        consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
          .BillPaymentSystem
      );

      sessionStorage.setItem(
        "accountType",
        validarNulosYIndefinidios(
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .Type
        )
      );

      sessionStorage.setItem(
        "marketclass",
        validarNulosYIndefinidios(
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .MarketClass
        )
      );

      if (
        consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
          .BillPaymentSystem === "POS"
      ) {
        let ar1: any =
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .ListOfServiceInstance.ServiceInstance;

        ar1.forEach((item: any) => {
          if (
            item.SlaveHierarchy === "Master" &&
            item.ServiceProductType === "VIDEO"
          ) {
            let ar2: object[] = item.ListOfInstanceComponent.InstanceComponent;

            ar2.forEach((item2: any) => {
              if (item2.ProductCategory === "Paquete Principal") {
                sessionStorage.setItem(
                  "Paquete",
                  validarNulosYIndefinidios(item2.Product)
                );
                let banderaHD = validarNulosYIndefinidios(item2.Product);
                let banderaHD2 = validarNulosYIndefinidios(
                  consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].AccountTechnology
                );

                if (
                  banderaHD.search("HD") ||
                  banderaHD.search("GOLD") ||
                  banderaHD.search("BLACK") ||
                  banderaHD.search("PLATINUM") ||
                  banderaHD2 === "HD"
                ) {
                  sessionStorage.setItem("banderaHD", "Y");
                } else {
                  sessionStorage.setItem("banderaHD", "N");
                }

                let fechaInicio = item2.EffectiveStartDate.substring(0, 10);
                sessionStorage.setItem("fechaInicioRecarga", fechaInicio);
                let fechaFin = item2.EffectiveEndDate;

                if (fechaFin !== null) {
                  fechaFin.substring(0, 10);
                  const ar2 = fechaFin.split("-");
                  sessionStorage.setItem(
                    "fechaFinRecarga",
                    ar2[2] + "-" + ar2[1] + "-" + ar2[0]
                  );
                } else {
                  sessionStorage.setItem("fechaFinRecarga", fechaFin);
                }
              }
            });
          }
          sessionStorage.setItem(
            "StreetAddrCalle",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
            )
          );
          sessionStorage.setItem(
            "AddrNumNumExt",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
            )
          );
          sessionStorage.setItem(
            "AddrNumNumInt",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].NumInt
            )
          );
          sessionStorage.setItem(
            "ProvinceColonia",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
            )
          );
          sessionStorage.setItem(
            "PrimaryAccountCountry",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].PrimaryAccountCountry
            )
          );
          setBanderaPais(true);
          setPais("MEX");

          sessionStorage.setItem(
            "CountyDelMun",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].CountyDelMun
            )
          );
          sessionStorage.setItem(
            "StateEstado",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].StateEstado
            )
          );
          sessionStorage.setItem(
            "PostalCodeCP",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
            )
          );
          sessionStorage.setItem(
            "direccion",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
            ) +
              " no. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
              ) +
              " no. interior " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].NumInt
              ) +
              ", Col. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
              ) +
              ", " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].CityPoblacion
              ) +
              ", " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].StateEstado
              ) +
              ", C.P. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
              )
          );

          sessionStorage.setItem(
            "assetNumber",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance[0].AssetNumber
            )
          );

          sessionStorage.setItem(
            "SecondAssetNumber",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance[0]
                .SecondAssetNumber
            )
          );

          sessionStorage.setItem(
            "assetNumberVideo",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].ListOfServiceInstance.ServiceInstance.find(
                (x: any) =>
                  x.ServiceProductType === "VIDEO" &&
                  x.SlaveHierarchy === "Master" /*&& x.StatusCode === "Activo"*/
              )?.AssetNumber
            )
          );

          sessionStorage.setItem(
            "SecondAssetNumberVideo",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].ListOfServiceInstance.ServiceInstance.find(
                (x: any) =>
                  x.ServiceProductType === "VIDEO" &&
                  x.SlaveHierarchy === "Master" /*&& x.StatusCode === "Activo"*/
              )?.SecondAssetNumber
            )
          );
        });
      } else {
        //Inicia seccion para prepago
        let ar1: any =
          consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .ListOfServiceInstance.ServiceInstance;

        ar1.forEach((item: any) => {
          if (
            item.SlaveHierarchy === "Master" &&
            item.ServiceProductType === "VIDEO"
          ) {
            let ar2: object[] = item.ListOfInstanceComponent.InstanceComponent;

            ar2.forEach((item2: any) => {
              if (
                item2.ProductCategory === "Service" ||
                item2.ProductCategory === "Paquete Principal"
              ) {
                let miPaquete: string = "";
                if (
                  consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].AccountTechnology === "SD"
                ) {
                  miPaquete = `${consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTypeRecharge}`;
                } else {
                  miPaquete = `${consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTypeRecharge} ${consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTechnology}`;
                }
                //sessionStorage.setItem("Paquete",validarNulosYIndefinidios(item2.Product));
                sessionStorage.setItem(
                  "Paquete",
                  validarNulosYIndefinidios(miPaquete)
                );
                let banderaHD = validarNulosYIndefinidios(item2.Product);
                let banderaHD2 = validarNulosYIndefinidios(
                  consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].AccountTechnology
                );

                if (
                  banderaHD.search("HD") ||
                  banderaHD.search("GOLD") ||
                  banderaHD.search("BLACK") ||
                  banderaHD.search("PLATINUM") ||
                  banderaHD2 === "HD"
                ) {
                  sessionStorage.setItem("banderaHD", "Y");
                } else {
                  sessionStorage.setItem("banderaHD", "N");
                }
              }
            });
          }

          sessionStorage.setItem(
            "Estatus",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].EstatusVeTV
            )
          );
          sessionStorage.setItem(
            "AddrNumNumExt",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
            )
          );
          sessionStorage.setItem(
            "AddrNumNumInt",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].NumInt
            )
          );
          sessionStorage.setItem(
            "ProvinceColonia",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
            )
          );
          sessionStorage.setItem(
            "PrimaryAccountCountry",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].PrimaryAccountCountry
            )
          );
          sessionStorage.setItem(
            "CountyDelMun",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].CountyDelMun
            )
          );
          sessionStorage.setItem(
            "StateEstado",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].StateEstado
            )
          );

          sessionStorage.setItem(
            "PostalCodeCP",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
            )
          );
          sessionStorage.setItem(
            "direccion",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
            ) +
              " no. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
              ) +
              " no. interior" +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].NumInt
              ) +
              ", Col. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
              ) +
              ", " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].CityPoblacion
              ) +
              ", " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].StateEstado
              ) +
              ", C.P. " +
              validarNulosYIndefinidios(
                consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
              )
          );
          sessionStorage.setItem(
            "CountryPais",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfAddress.AccountAddress[0].CountryPais
            )
          );
          setBanderaPais(true);
          setPais(
            consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
              .Account[0].ListOfAddress.AccountAddress[0].CountryPais
          );

          sessionStorage.setItem(
            "montoPaquete",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceAgreement.ServiceAgreement[0]
                .SubscriptionAmount
            )
          );

          sessionStorage.setItem(
            "assetNumber",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance[0].AssetNumber
            )
          );

          sessionStorage.setItem(
            "SecondAssetNumber",
            validarNulosYIndefinidios(
              consultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance[0]
                .SecondAssetNumber
            )
          );
        });
      } //termina seccion de prepago

      doConsultarServiciosCuenta();
    } else {
      isLoading(false);
      console.error(consultaCuentaRespuesta.EBMHeaderResponse);
      setStatus({
        show: true,
        color: "red",
        message:
          "Ocurrió un error con la petición, favor de intentar más tarde",
      });
      handleShowModalError();
    }
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const doAutenticarUsuarioRest = async () => {
    //----------------------------------------------------------------------------------------------------------------------------
    const AutenticarUsuarioRestDO: AutenticarUsuarioRest_Datos =
      builtAutenticarUsuarioRest_Datos(`${user}`, `${encryptText(`${pwd}`)}`);

    //guardar el pass desencriptado

    sessionStorage.setItem("kyriaVar", encryptText(`${pwd}`));

    let par = AutenticarUsuarioRest_Parametros(
      AutenticarUsuarioRestDO,
      capchaToken
    );
    let AutenticarUsuarioRestRespuesta: AutenticarUsuarioRest_Respuesta =
      await ConsultaWS(par);

    if (
      AutenticarUsuarioRestRespuesta.EBMHeaderResponse.ErrorNegocio
        .CodigoError == "0"
    ) {
      //DTH
      setDatosSW(AutenticarUsuarioRestRespuesta);

      sessionStorage.setItem(
        "cuenta",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .NumeroCuenta
        )
      );
      //CUENTA CORPORATIVA
      doConsultarDatosUsuario(user);

      sessionStorage.setItem(
        "EmailNotif",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .EmailNotif
        )
      );
      sessionStorage.setItem(
        "NombreSuscriptor",
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NombreSuscriptor
      );
      sessionStorage.setItem(
        "Producto",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .Producto
        )
      );
      sessionStorage.setItem(
        "TelCasa",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .TelCasa
        )
      );
      sessionStorage.setItem(
        "TelCasaLada",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .TelCasaLada
        )
      );
      sessionStorage.setItem(
        "TelMovil",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .TelMovil
        )
      );
      let vTipoCuenta =
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .TipoCuenta;
      sessionStorage.setItem(
        "TipoCuenta",
        validarNulosYIndefinidios(vTipoCuenta)
      );

      sessionStorage.setItem(
        "Nombre",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0].Nombre
        )
      );
      sessionStorage.setItem(
        "APaterno",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .APaterno
        )
      );
      sessionStorage.setItem(
        "AMaterno",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .AMaterno
        )
      );

      sessionStorage.setItem("Usuario", user);

      //Aqui verificamos si tiene sky+ y celular
      let resOTT: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "OTT"
      );
      let resCelular: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Celular"
      );
      let resBundle: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Bundle"
      );
      let resInternet: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Internet"
      );

      let flujos = { celular: false, skyplus: false };

      let arrayAcumulador: Asset[] = [];

      if (resOTT !== undefined) {
        resOTT.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resCelular !== undefined) {
        sessionStorage.setItem(
          "showSkyCelularMenu",
          JSON.stringify(resCelular.length > 0)
        );
        resCelular.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resBundle !== undefined) {
        resBundle.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resInternet !== undefined) {
        resInternet.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (arrayAcumulador.length > 0) {
        sessionStorage.setItem("assets", JSON.stringify(arrayAcumulador));

        arrayAcumulador.forEach((element: Asset) => {
          if (element.family === "Android TV") {
            flujos.skyplus = true;
          }
          if (element.family === "Movil") {
            flujos.celular = true;
          }
        });

        arrayAcumulador.forEach((item: Asset) => {
          if (item.family === "Servicio Base") {
            sessionStorage.setItem("PaqueteSky+", item.productName);
          }
        });

        let dataPrimary: any = await getPrimaryData(
          user.toLowerCase(),
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .NumeroCuenta
        );

        if (
          dataPrimary &&
          dataPrimary !== null &&
          typeof dataPrimary != "undefined"
        ) {
          sessionStorage.setItem("dataPrimary", JSON.stringify(dataPrimary));
          getAccountDetails(dataPrimary.userId);
          sessionStorage.setItem("cuentaSkyPlus", dataPrimary.accountNumber);
          sessionStorage.setItem("userId", dataPrimary.userId);
          setSkyPlus({ estado: true });
          setDTHSkyPlus({ estado: false });
        }

        //establecemos banderas para flujos
        if (flujos.skyplus === true && flujos.celular === true) {
          sessionStorage.setItem("flujos", "DTH/SkyCelular/Sky+");
        } else if (flujos.skyplus === true) {
          sessionStorage.setItem("flujos", "DTH/Sky+");
        } else if (flujos.celular === true) {
          sessionStorage.setItem("flujos", "DTH/SkyCelular");
          setSkyCelular({ estado: true });
          setDTHSkyPlus({ estado: true });
        }
      } else {
        sessionStorage.setItem("flujos", "DTH");
        setDTHSkyPlus({ estado: true });
      }

      doConsultaCuenta(AutenticarUsuarioRestRespuesta);
    } else if (
      AutenticarUsuarioRestRespuesta.EBMHeaderResponse.ErrorNegocio
        .CodigoError == "1"
    ) {
      //Aqui entra solo para SKY+
      sessionStorage.setItem(
        "cuenta",
        validarNulosYIndefinidios(
          AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
            .NumeroCuenta
        )
      );

      let resOTT: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "OTT"
      );
      let resCelular: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Celular"
      );
      let resBundle: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Bundle"
      );
      let resInternet: any = await getAssetsFromSalesfoce(
        user,
        AutenticarUsuarioRestRespuesta.ListUsuariosSel.UsuarioSelEBO[0]
          .NumeroCuenta,
        "Internet"
      );
      let arrayAcumulador: Asset[] = [];

      if (resOTT !== undefined) {
        resOTT.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resCelular !== undefined) {
        sessionStorage.setItem(
          "showSkyCelularMenu",
          JSON.stringify(resCelular.length > 0)
        );
        resCelular.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resBundle !== undefined) {
        resBundle.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }

      if (resInternet !== undefined) {
        resInternet.forEach((asseti: Asset) => {
          arrayAcumulador.push(asseti);
        });
      }
      sessionStorage.setItem("flujos", "Sky+");
      sessionStorage.setItem("assets", JSON.stringify(arrayAcumulador));

      arrayAcumulador.forEach((item: Asset) => {
        if (item.family === "Servicio Base") {
          sessionStorage.setItem("PaqueteSky+", item.productName);
          sessionStorage.setItem("Producto", item.productName);
        }
      });
      sessionStorage.setItem("user", user);
      let dataPrimary: any = await getPrimaryData(user, " ");

      if (
        dataPrimary &&
        dataPrimary !== null &&
        typeof dataPrimary != "undefined"
      ) {
        sessionStorage.setItem("dataPrimary", JSON.stringify(dataPrimary));

        sessionStorage.setItem("Nombre", dataPrimary.name);
        let ar = dataPrimary.name.split(" ");
        sessionStorage.setItem("nombre", ar[0]);
        sessionStorage.setItem("cuentaSkyPlus", dataPrimary.accountNumber);
        sessionStorage.setItem("userId", dataPrimary.userId);
        //sessionStorage.setItem("user", dataPrimary.username);
        getAccountDetails(dataPrimary.userId);

        sessionStorage.setItem("tipoCliente", "POS"); //revisar con axel
        sessionStorage.setItem("authenticated", "true");
        setSkyPlus({ estado: false });
        setDTHSkyPlus({ estado: false });

        isLoading(false);
        //reload()

        doConsultarServiciosCuenta();

        navigate("/inicio");
      } else {
        isLoading(false);
        console.error("NO HAY DATOS PRIMARIOS PARA MOSTRAR");
        setStatus({
          show: true,
          color: "red",
          message:
            "Ocurrió un error con la petición, favor de intentar más tarde",
        });
      }

      //sessionStorage.setItem("dataPrimary", JSON.stringify(dataPrimary));
      //sessionStorage.setItem("Nombre", dataPrimary.name);
      //let ar = dataPrimary.name.split(" ");
      //sessionStorage.setItem("nombre", ar[0]);
      //sessionStorage.setItem("cuentaSkyPlus", dataPrimary.accountNumber);
      //sessionStorage.setItem("userId", dataPrimary.userId);
      //sessionStorage.setItem("dataPrimary", JSON.stringify(dataPrimary));
      //sessionStorage.setItem("Nombre", dataPrimary.name);
      //let ar = dataPrimary.name.split(" ");
      //sessionStorage.setItem("nombre", ar[0]);
      //sessionStorage.setItem("cuentaSkyPlus", dataPrimary.accountNumber);
      //sessionStorage.setItem("userId", dataPrimary.userId);
    } else {
      isLoading(false);
      setStatus({
        show: true,
        color: "red",
        message:
          "Ocurrió un error con la petición, favor de intentar más tarde",
      });
      handleShowModalError();
      console.error(AutenticarUsuarioRestRespuesta.EBMHeaderResponse);
    }
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const getAccountDetails = async (cuenta: string) => {
    isLoading(true);

    const accountDetailsDO: AccountDetails_Entrada = { userId: cuenta };
    let accountDetailsParametros = AccountDetails_Parametros(accountDetailsDO);

    let accountDetailsRespuesta: AccountDetails_Respuesta = await ConsultaWS(
      accountDetailsParametros
    );

    if (
      accountDetailsRespuesta.errormessage === "Ok" &&
      accountDetailsRespuesta.errorno == 0
    ) {
      sessionStorage.setItem(
        "cuenta",
        accountDetailsRespuesta.Account.Account.AccountNumber
      );

      let date = new Date();
      let cadena = date.toLocaleString();
      let cadenas = cadena.split(",");
      let fechas = cadenas[0].split("/");
      let hora = cadenas[1].split(":");
      sessionStorage.setItem(
        "idSesion",
        fechas[2] +
          fechas[0] +
          fechas[1] +
          hora[0].trimStart() +
          hora[1] +
          hora[2].slice(0, 2) +
          accountDetailsRespuesta.Account.Account.AccountNumber
      );

      sessionStorage.setItem(
        "EmailNotif",
        accountDetailsRespuesta.Account.Contact.Email
      );
      sessionStorage.setItem(
        "TelCasa",
        accountDetailsRespuesta.Account.Contact.Phone
      );

      sessionStorage.setItem(
        "TelCasa",
        accountDetailsRespuesta.Account.Contact.Phone
      );

      sessionStorage.setItem(
        "Nombre",
        accountDetailsRespuesta.Account.Contact.FirstName
      );
      sessionStorage.setItem(
        "APaterno",
        accountDetailsRespuesta.Account.Contact.MiddleName
      );
      sessionStorage.setItem(
        "AMaterno",
        accountDetailsRespuesta.Account.Contact.LastName
      );

      sessionStorage.setItem(
        "StreetAddrCalle",
        accountDetailsRespuesta.Account.Account.Billing.Street
      );
      sessionStorage.setItem(
        "AddrNumNumExt",
        accountDetailsRespuesta.Account.Account.Billing.StreetNumber
      );
      sessionStorage.setItem(
        "ProvinceColonia",
        accountDetailsRespuesta.Account.Account.Billing.District
      );
      sessionStorage.setItem(
        "PrimaryAccountCountry",
        accountDetailsRespuesta.Account.Account.Billing.Country
      );
      if (banderaPais === false) {
        setPais("MEX");
      }
      sessionStorage.setItem(
        "CountyDelMun",
        accountDetailsRespuesta.Account.Account.Billing.Delegation
      );
      sessionStorage.setItem(
        "StateEstado",
        accountDetailsRespuesta.Account.Account.Billing.State
      );
      sessionStorage.setItem(
        "PostalCodeCP",
        accountDetailsRespuesta.Account.Account.Billing.PostalCode
      );

      sessionStorage.setItem(
        "accountDetails",
        JSON.stringify(accountDetailsRespuesta.Account)
      );

      isLoading(false);
    } else {
      isLoading(false);
    }
  };

  const doConsultarCuentaEspecial = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------

      const ConsultarCuentaEspeciaEntrada: ConsultarCuentaEspecial_Entrada =
        builtConsultarCuentaEspecial_Entrada(p_numerocuenta);
      let ConsultarCuentaEspecialParametros =
        ConsultarCuentaEspecial_Parametros(ConsultarCuentaEspeciaEntrada);

      let ConsultarCuentaEspecialRespuesta: ConsultarCuentaEspecial_Respuesta =
        await ConsultaWS(ConsultarCuentaEspecialParametros);

      if (
        ConsultarCuentaEspecialRespuesta.CuentaSKY &&
        ConsultarCuentaEspecialRespuesta.CuentaSKYPadre &&
        ConsultarCuentaEspecialRespuesta.CuentaSKY != null &&
        ConsultarCuentaEspecialRespuesta.CuentaSKYPadre != null
      ) {
        sessionStorage.setItem("esCuentaCorporativaRefresco", "0");

        sessionStorage.setItem("esCuentaCorporativaInicial", p_numerocuenta);
        sessionStorage.setItem(
          "esCuentaCorporativaNombreCorporativo",
          validarNulosYIndefinidios(
            ConsultarCuentaEspecialRespuesta.NombreGrupo
          )
        );
        if (
          ConsultarCuentaEspecialRespuesta.CuentaSKY ===
          ConsultarCuentaEspecialRespuesta.CuentaSKYPadre
        ) {
          sessionStorage.setItem("esCuentaCorporativaJerarquia", "false");
        } else {
          sessionStorage.setItem("esCuentaCorporativaJerarquia", "true");
        }
        doConsultarCuentaAsociada(p_numerocuenta);
      } else {
        console.error(ConsultarCuentaEspecialRespuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
    }
  };

  const doConsultarCuentaAsociada = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------

      const ConsultarCuentaAsociadaEntrada: ConsultarCuentaAsociada_Entrada =
        builtConsultarCuentaAsociada_Entrada(p_numerocuenta);
      let ConsultarCuentaAsociadaParametros =
        ConsultarCuentaAsociada_Parametros(ConsultarCuentaAsociadaEntrada);

      let ConsultarCuentaAsociadaRespuesta: ConsultarCuentaAsociada_Respuesta =
        await ConsultaWS(ConsultarCuentaAsociadaParametros);

      if (
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta &&
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta.length > 0 &&
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta != null
      ) {
        sessionStorage.setItem(
          "esCuentaCorporativaArray",
          JSON.stringify(ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta)
        );
      } else {
        console.error("No hay cuentas Hijas recuperadas");
        sessionStorage.setItem("esCuentaCorporativaArray", JSON.stringify([]));
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error("No hay cuentas Hijas recuperadas", error);
      sessionStorage.setItem("esCuentaCorporativaArray", JSON.stringify([]));
    }
  };

  const handleSubmit = async () => {
    setStatus({ show: false, color: "red", message: "" });

    if (user == "" || pwd == "") {
      setStatus({
        show: true,
        color: "red",
        message: "Todos los campos son obligatorios",
      });
      console.error(status.message);
      return;
    } else {
      setStatus({ show: true, color: "red", message: "Validando..." });
      isLoading(true);
      doAutenticarUsuarioRest();
    } //fin de else
  };

  const doConsultarServiciosCuenta = async () => {
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultarServiciosCuentaDO: ConsultarServiciosCuenta_Entrada =
      builtInputVarConsultarServiciosCuentaInput(
        `${
          flujo === "Sky+"
            ? sessionStorage.getItem("cuenta")!
            : sessionStorage.getItem("cuenta")!
        }`
      );
    let par = ConsultarServiciosCuenta_Parametros(ConsultarServiciosCuentaDO);
    let ConsultarServiciosCuentaRespuesta: ConsultarServiciosCuenta_Respuesta =
      await ConsultaWS(par);

    if (
      ConsultarServiciosCuentaRespuesta.EBMHeaderResponse &&
      ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ==
        "ok" &&
      ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
        "ok"
    ) {
      sessionStorage.setItem(
        "pais",
        validarNulosYIndefinidios(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Pais
        )
      );

      setPais(ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Pais);

      sessionStorage.setItem(
        "diferenciaGMT",
        validarNulosYIndefinidios(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.DiferenciaHoraria
        )
      );
      sessionStorage.setItem(
        "rowId",
        validarNulosYIndefinidios(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId
        )
      );
      sessionStorage.setItem(
        "RowIdContacto",
        validarNulosYIndefinidios(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId
        )
      );

      sessionStorage.setItem(
        "BanderaNoOPPV",
        validarNulosYIndefinidios(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.BanderaNoOPPV
        )
      );
      sessionStorage.setItem(
        "servicios",
        JSON.stringify(
          ConsultarServiciosCuentaRespuesta.ListServicios.ServicioEBO
        )
      );
      sessionStorage.setItem("btiFlag", "0");
      validateBTI(ConsultarServiciosCuentaRespuesta.ListServicios.ServicioEBO);

      let date = new Date();
      let cadena = date.toLocaleString();
      let cadenas = cadena.split(",");
      let fechas = cadenas[0].split("/");
      let hora = cadenas[1].split(":");
      sessionStorage.setItem(
        "idSesion",
        fechas[2] +
          fechas[0] +
          fechas[1] +
          hora[0].trimStart() +
          hora[1] +
          hora[2].slice(0, 2) +
          sessionStorage.getItem("cuenta")
      );

      sessionStorage.setItem(
        "organizacion",
        ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Organizacion
      );

      doConsultarIRD(ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId);
    } else {
      console.error(ConsultarServiciosCuentaRespuesta.EBMHeaderResponse);
      isLoading(false);
      setStatus({
        show: true,
        color: "red",
        message:
          "Ocurrió un error con la petición, favor de intentar más tarde",
      });
    }
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const validateBTI = (ServicioEBO: ServicioEBO[]) => {
    for (let i = 0; i < ServicioEBO.length; i++) {
      if (
        ServicioEBO[i].ServiceProductType.toLowerCase().includes("datos") ||
        ServicioEBO[i].ServiceProductType.toLowerCase().includes("CELULAR")
      ) {
        setBti({ estado: true });

        sessionStorage.setItem("btiFlag", "1");
        break;
      }
    }
  };

  const doConsultarIRD = async (param: string) => {
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultarIRDDO: ConsultarIRD_Entrada = { RowID: `${param}` };
    let ConsultarIRDPar = ConsultarIRD_Parametros(ConsultarIRDDO);

    let ConsultarIRDRespuesta: ConsultarIRD_Respuesta =
      await ConsultaWS(ConsultarIRDPar);

    if (
      ConsultarIRDRespuesta.Tarjeta &&
      ConsultarIRDRespuesta.Tarjeta.length > 0
    ) {
      sessionStorage.setItem(
        "tarjetas",
        JSON.stringify(ConsultarIRDRespuesta.Tarjeta)
      );
      obtenerTIMaster(ConsultarIRDRespuesta.Tarjeta);
      //reload()

      navigate("/inicio");
      isLoading(false);
    } else {
      setStatus({
        show: true,
        color: "red",
        message:
          "Ocurrió un error con la petición, favor de intentar más tarde",
      });
      console.error("Se sigue el flujo pero sin tarjetas");

      navigate("/inicio");
      isLoading(false);
    }
  };

  const obtenerTIMaster = (p_Tarjeta: Tarjeta[]) => {
    for (let index = 0; index < p_Tarjeta.length; index++) {
      if (p_Tarjeta[index].Jerarquia === "Master") {
        sessionStorage.setItem(
          "tarjetaMaster",
          JSON.stringify(p_Tarjeta[index])
        );
        break;
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key == "Enter") {
      handleSubmit();
    }
  };

  const getLocation = async () => {
    const API_URL = `https://geolocation-db.com/json/`;
    axios
      .get(API_URL)
      .then(function (response) {
        sessionStorage.setItem(
          "IPv4",
          validarNulosYIndefinidios(response.data.IPv4)
        );
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const validaCorreo = (cadena: string) => {
    regExDir.test(cadena) === true
      ? setUser(cadena)
      : setUser(cadena.substring(0, cadena.length - 1));
  };

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    setStatus({
      show: true,
      color: "orange",
      message: "Acción no permitida",
    });

    setTimeout(() => {
      setStatus({
        show: false,
        color: "orange",
        message: "",
      });
    }, 4000);
  };

  const handleRecaptcha = useCallback((token: string | null) => {
    setCapchaToken(token || "");
    getLocation();
  }, []);

  const doConsultarDatosUsuario = async (p_correo: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      var consultarDatosUsuario_Entrada: ConsultarDatosUsuario_Entrada =
        builtConsultarDatosUsuario_Entrada(p_correo);
      let consultarDatosUsuario_Parametros = ConsultarDatosUsuario_Parametros(
        consultarDatosUsuario_Entrada
      );
      let consultarDatosUsuario_Respuesta: ConsultarDatosUsuario_Respuesta =
        await ConsultaWS(consultarDatosUsuario_Parametros);
      if (
        consultarDatosUsuario_Respuesta &&
        consultarDatosUsuario_Respuesta.respuesta == "0" &&
        consultarDatosUsuario_Respuesta.respuestadesc === "0"
      ) {
        sessionStorage.setItem(
          "esCuentaCorporativa",
          consultarDatosUsuario_Respuesta.TIPO_CUENTA === "C" ? "V" : "F"
        );

        if (
          consultarDatosUsuario_Respuesta.TIPO_CUENTA === "C" ||
          consultarDatosUsuario_Respuesta.TIPO_CUENTA === "V"
        ) {
          sessionStorage.setItem(
            "esCuentaCorporativaNombreCompletoTMP",
            consultarDatosUsuario_Respuesta.NOMBRE_COMPLETO
          );
          doConsultarCuentaEspecial(sessionStorage.getItem("cuenta")!);
        }
      } else {
        console.error(consultarDatosUsuario_Respuesta);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      handleShowModalError();
      console.error(error);
    }
  };

  return (
    <>
      <Container className={styles.container}>
        {loading === true ? <BarraLoader /> : <></>}

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["loginForm"]}
          >
            <Form className={styles.estiloForm} method="POST">
              <img src={imagenURI} className={styles.logo} />
              <p className={styles.titulo}>Bienvenido a Mi Sky</p>
              <hr className={styles["line"]} />
              {/* <Row>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    paddingRight: "0px",
                  }}
                >
                  <Button className={styles.botonSwitchActivo}>
                    Tengo otros productos Sky
                  </Button>
                </Col>
                <Col style={{ paddingLeft: "0px" }}>
                  <Button className={styles.botonSwitchInactivo}>
                    <a
                      href="https://miespaciosky.sky.com.mx"
                      className={styles.enlace}
                    >
                      Tengo Sky Satelital
                    </a>
                  </Button>
                </Col>
              </Row> */}
              <Form.Group
                className={styles.label + " mb-4 mt-4 " + styles.hiContainer}
              >
                <h1
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabelCenter}
                >
                  ¡Hola de nuevo!
                </h1>
              </Form.Group>
              <Form.Group
                className={styles.label + " mb-3"}
                controlId="formBasicEmail"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  E-mail
                </Form.Label>

                <Form.Control
                  type="email"
                  placeholder="usuario@sky.com.mx"
                  value={user}
                  onCopy={(e: any) => preventCopyPaste(e)}
                  onPaste={(e: any) => preventCopyPaste(e)}
                  onCut={(e: any) => preventCopyPaste(e)}
                  onChange={(e) => validaCorreo(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="pwdGroup">
                <Form.Label> Contraseña</Form.Label>

                <InputGroup className="mb-3">
                  <Form.Control
                    type={typePwd}
                    value={pwd}
                    onChange={(e) => setPwd(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Contraseña"
                    className={styles["formPasswordText"]}
                  />
                  <Button
                    variant="outline-secondary"
                    id="button-addon1"
                    className={styles["formPasswordButton"]}
                    onClick={handleShowNumber}
                  >
                    {typePwd === "password" ? (
                      <RxEyeClosed />
                    ) : (
                      <MdRemoveRedEye />
                    )}
                  </Button>
                </InputGroup>
              </Form.Group>
              <Form.Group>
                <Link
                  to="/sky/forget-password"
                  className="text-sky-blue-100 underline underline-offset-3 text-end cursor-pointer font-normal text-sm"
                ></Link>
              </Form.Group>
              <Row>
                <a
                  onClick={() => navigate("/forgot")}
                  className={styles["forgot"]}
                  style={{ textAlign: "right" }}
                >
                  <span style={{ textAlign: "right" }} className="text-end">
                    ¿Olvidaste tu contraseña?
                  </span>
                </a>
              </Row>

              <Row>
                <Col className={styles[""]}>
                  <Button
                    className={styles["btn-secondary-link"]}
                    onClick={handleShowModal}
                  >
                    Reenviar Correo de Confirmación
                  </Button>
                </Col>
              </Row>

              <div className="flex flex-col justify-center">
                {process.env.REACT_APP_CAPTCHA_KEY && (
                  <ReCAPTCHA
                    ref={captchaRef}
                    type="image"
                    sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                    onChange={handleRecaptcha}
                  />
                )}
                {/*onChange={(value) => setValue('captcha', value)} */}
                {/*errors.captcha?.message && <p className='text-sm font-light mb-2 text-[#ef4444]'>{errors.captcha.message}</p>*/}
              </div>
              <Row>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    onClick={handleSubmit}
                  >
                    Ingresar
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col className="center text-center">
                  <span className="center">¿Aún no tienes cuenta?</span>{" "}
                  <a
                    onClick={() => navigate("/registrar")}
                    className={styles["registrar"]}
                  >
                    <span className="text-end">Regístrate</span>
                  </a>
                </Col>
              </Row>

              {status.show && (
                <p style={{ color: status.color }}>{status.message}</p>
              )}
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} />
          </Col>
        </Row>
        <Modal
          className={styles.contenedorModal}
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="border-0" closeButton></Modal.Header>
          <Modal.Body>
            <Container className={styles["containerModal"]}>
              {!solicitudCorreo ? (
                <>
                  <Row>
                    <h4
                      className={
                        "text-center " + styles["tituloModal"] + " mb-2"
                      }
                    >
                      Reenviar Correo de Confirmación
                    </h4>
                  </Row>

                  <Form.Group
                    className={styles.label + " mb-3"}
                    controlId="formBasicEmail"
                  >
                    <Form.Label
                      style={{ marginBottom: "0px" }}
                      className={styles.estiloLabels}
                    >
                      E-mail
                    </Form.Label>

                    <Form.Control
                      type="email"
                      placeholder=""
                      value={correoReenvio}
                      onChange={(e) => validarCampo(e.target.value, "correo")}
                      onBlur={(e) => validarCampo(e.target.value, "correo")}
                    />
                  </Form.Group>

                  {true && (
                    <p style={{ color: statusCorreoRe.color }}>
                      {statusCorreoRe.message}
                    </p>
                  )}

                  <Form.Group
                    className={styles.label + " mb-3"}
                    controlId="formBasicEmail"
                  >
                    <Form.Label
                      style={{ marginBottom: "0px" }}
                      className={styles.estiloLabels}
                    >
                      Confirmar E-mail
                    </Form.Label>

                    <Form.Control
                      type="email"
                      placeholder=""
                      value={correoReenvioConfirma}
                      onChange={(e) =>
                        validarCampo(e.target.value, "confirmar")
                      }
                      onBlur={(e) => validarCampo(e.target.value, "confirmar")}
                    />
                  </Form.Group>

                  {statusCorreoReConfirma.show && (
                    <p style={{ color: statusCorreoReConfirma.color }}>
                      {statusCorreoReConfirma.message}
                    </p>
                  )}

                  <Row>
                    <Col className={styles["buttonContainer"]}>
                      <Button
                        variant="btn btn-primary"
                        className={styles.boton}
                        onClick={handleCloseModal}
                      >
                        Cancelar
                      </Button>
                    </Col>
                    <Col className={styles["buttonContainer"]}>
                      <Button
                        variant="btn btn-primary"
                        className={styles.boton}
                        onClick={handleReenviarCorreoSubmit}
                      >
                        Enviar
                      </Button>
                    </Col>
                  </Row>

                  {statusModal.show && (
                    <p style={{ color: statusModal.color }}>
                      {statusModal.message}
                    </p>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    <h4 className={"text-2xl text-center mb-2 p-5"}>
                      {mensajeSolicitudCorreo}
                    </h4>
                  </Row>
                  {showModalError && <div className="modal-overlay"></div>}

                  <Modal
                    className={styles.contenedorModal}
                    show={showModalError}
                    onHide={handleCloseModalError}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header
                      className="border-0"
                      closeButton
                    ></Modal.Header>
                    <Modal.Body>
                      <Container className={styles["containerModal"]}>
                        <>
                          <Row>
                            <h4
                              className={
                                "text-center " + styles["tituloModal"] + " mb-2"
                              }
                            >
                              Verifica tus credenciales
                            </h4>
                          </Row>
                          <Row>
                            <p className={"text-center " + " mb-2"}>
                              Si tu cuenta se ha activado después de Marzo 2025
                            </p>
                          </Row>
                          <Row>
                            <Col className="col-12 mb-2 text-center">
                              <Button
                                variant="btn btn-primary"
                                className={styles.boton}
                                style={{ width: "200px", marginTop: "40px" }}
                                href={"https://www.google.com/"}
                              >
                                Iniciar sesión aquí
                              </Button>
                            </Col>
                            <Col className="col-12 text-center">
                              <Button
                                variant="btn btn-secondary-link"
                                className={styles["intentar"]}
                                style={{ marginTop: "-20px" }}
                                onClick={() => {
                                  navigate("/login");
                                  handleCloseModalError();
                                }}
                              >
                                Intentar de nuevo
                              </Button>
                            </Col>
                          </Row>
                        </>
                      </Container>
                    </Modal.Body>
                  </Modal>
                </>
              )}
            </Container>
          </Modal.Body>
        </Modal>
        <Modal
          className={styles.contenedorModal}
          show={showModalError}
          onHide={handleCloseModalError}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }} // Controla la opacidad del fondo
        >
          <Modal.Header className="border-0" closeButton></Modal.Header>
          <Modal.Body>
            <Container className={styles["containerModal"]}>
              <>
                <Row>
                  <h4
                    className={"text-center " + styles["tituloModal"] + " mb-2"}
                  >
                    Verifica tus credenciales
                  </h4>
                </Row>
                <Row>
                  <p className={"text-center " + " mb-2"}>
                    Si tu cuenta se ha activado después de Marzo 2025
                  </p>
                </Row>
                <Row>
                  <Col className="col-12 mb-2 text-center">
                    <Button
                      variant="btn btn-primary"
                      className={styles.boton}
                      style={{ width: "200px", marginTop: "40px" }}
                      href={"https://micuenta.sky.com.mx/login"}
                    >
                      Iniciar sesión aquí
                    </Button>
                  </Col>
                  <Col className="col-12 text-center">
                    <Button
                      variant="btn btn-secondary-link"
                      className={styles["intentar"]}
                      style={{ marginTop: "-20px" }}
                      onClick={() => {
                        navigate("/login");
                        handleCloseModalError();
                      }}
                    >
                      Intentar de nuevo
                    </Button>
                  </Col>
                </Row>
              </>
            </Container>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};
